import React, { useEffect } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { t } from 'i18next';
import { Content } from './Content/content';
import { ITransactionElement } from '../transactionElement';
import { IGame } from '../../../providers/Games/useGames';
import { UserIcon } from '../../../common/components/icons/user';
import { GameIcon } from '../../../common/components/icons/game';
import { ethers } from 'ethers';

interface IDescription {
	children: React.ReactNode;
}

export interface IDetailInfo extends Pick<ITransactionElement, 'data'> {
	customTheme?: IGame['colors'];
}

const Description = ({ children }: IDescription) => (
	<GridItem
		fontSize="10px"
		lineHeight="13px"
		textAlign="right"
		display={{ base: 'none', hashup: 'block' }}
	>
		{children}
	</GridItem>
);

enum ImageRepresentationType {
	USER,
	GAME,
	AVATAR,
	DESCRIPTION,
	NICKNAME,
}

const ImageRepresentation = ({ type }: { type: ImageRepresentationType }) => {
	const typeUri: { [p: number]: () => React.ReactNode } = {
		[ImageRepresentationType.USER]: () => <UserIcon />,
		[ImageRepresentationType.GAME]: () => <GameIcon />,
	};

	return <GridItem>{typeUri[type]()}</GridItem>;
};

export const DetailInfo = ({ data, customTheme }: IDetailInfo) => {
	return (
		<Grid
			templateRows="repeat(3, auto)"
			templateColumns="repeat(3, auto)"
			rowGap="6px"
			columnGap="8px"
			color="text"
			fontSize="12px"
			lineHeight="15px"
		>
			<Description>{t('transactions.user').toString()}:</Description>
			<ImageRepresentation type={ImageRepresentationType.USER} />
			<Content
				content={{ user: { address: data.user, name: data.userData.nickname } }}
				customTheme={customTheme}
			/>
			<Description>Marketplace:</Description>
			<ImageRepresentation type={ImageRepresentationType.USER} />
			<Content
				content={{
					user: { address: data.marketplace ? data.marketplace : ethers.constants.AddressZero, name: '' },
				}}
				customTheme={customTheme}
			/>
			<Description>{t('transactions.game').toString()}:</Description>
			<ImageRepresentation type={ImageRepresentationType.GAME} />
			<Content
				content={{ game: { address: data.token, name: data.gameData.name, amount: data.value } }}
				customTheme={customTheme}
			/>
		</Grid>
	);
};
